import React from 'react';
import PropTypes from 'prop-types';

import styles from './Group.scss';

var Group = function Group(_ref) {
  var children = _ref.children;
  return React.createElement(
    'div',
    { className: styles.root },
    children
  );
};

Group.displayName = 'Input.Group';
Group.propTypes = {
  children: PropTypes.node
};

export default Group;
//# sourceMappingURL=Group.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Input/Group/Group.js